export const EntityCollapsibleTextEvent = Object.freeze({
	ExpandButtonClick: 'ExpandButton.Click',
	CollapseButtonClick: 'CollapseButton.Click',
	HtmlFormatterComponentMouseUp: 'HtmlFormatterComponent.MouseUp',
	ByDefault: 'ByDefault',
	UpdateIsContentOverflowing: 'UpdateIsContentOverflowing',
});
